import axios from 'axios';
import serverMessage from '../server-message';

export default function update({ id, name, description, sortOrder, moduleIds }) {
  return new Promise((resolve, reject) => axios
    .put(`/account/system-admin/api/v1/bundle/${id}`, {
      name,
      description,
      sortOrder,
      moduleIds,
    })
    .then((response) => resolve(response.data))
    .catch((error) => reject(serverMessage(error))));
}
